import {
  PartnerBookApiPartnerRow,
  PartnerBookApiPartners,
} from '../types/PartnerBook';

type SparsePartnerRow = Record<string, string | number>;

export const isSparsePartnerRow = (
  row: unknown
): row is SparsePartnerRow =>
  typeof row === 'object' &&
  row !== null &&
  !Array.isArray(row) &&
  Object.prototype.hasOwnProperty.call(row, '0');

export const hydratePartnerRow = (
  row: PartnerBookApiPartnerRow,
  columnCount: number
): (string | number)[] => {
  if (Array.isArray(row)) {
    return row;
  }

  const dense = new Array(columnCount).fill(0) as (string | number)[];
  dense[0] = '';

  Object.entries(row).forEach(([index, value]) => {
    dense[Number(index)] = value;
  });

  return dense;
};

export const hydratePartnerBookPartners = (
  partners: PartnerBookApiPartners,
  columnCount: number,
  sparse?: boolean
): Record<string, (string | number)[]> => {
  if (!sparse) {
    const dense: Record<string, (string | number)[]> = {};
    Object.entries(partners).forEach(([id, row]) => {
      dense[id] = Array.isArray(row) ? row : hydratePartnerRow(row, columnCount);
    });
    return dense;
  }

  const hydrated: Record<string, (string | number)[]> = {};
  Object.entries(partners).forEach(([id, row]) => {
    hydrated[id] = hydratePartnerRow(row, columnCount);
  });
  return hydrated;
};
